import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { overviewCards } from "@/mocks/content";

interface OverviewProps {
  onSelectCategory: (key: string) => void;
}

export default function Overview({ onSelectCategory }: OverviewProps) {
  return (
    <section id="overview" className="relative py-16 md:py-24 bg-background-100/60">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <Reveal>
          <SectionHeading
            kicker="Overview"
            title="四大内容板块，先看清站里都有什么"
            desc="红桃影视的片库按题材划分为四个主要方向。弄清每个板块的气质，比盲目翻榜单更容易找到合你口味的片子。"
          />
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-10 md:mt-12">
          {overviewCards.map((card, i) => (
            <Reveal key={card.key} delay={i * 80}>
              <button
                type="button"
                onClick={() => onSelectCategory(card.key)}
                className="group w-full h-full text-left bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="w-11 h-11 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center text-xl">
                    <i className={card.icon} aria-hidden="true" />
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-300">
                    {card.index}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mt-5">
                  {card.title}
                </h3>
                <p className="font-label text-xs text-accent-700 mt-1.5">{card.count}</p>
                <p className="text-sm leading-relaxed text-foreground-600 mt-3">{card.desc}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {card.points.map((p) => (
                    <span
                      key={p}
                      className="font-label text-[11px] px-2 py-1 rounded-md bg-secondary-100 text-secondary-900"
                    >
                      {p}
                    </span>
                  ))}
                </div>
                <span className="mt-5 inline-flex items-center gap-1 font-label text-xs text-foreground-500 group-hover:text-primary-600 transition-colors">
                  在片库中筛选
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}